// extracted by mini-css-extract-plugin
export default {"header__item":"HeaderItem_header__item__nTtwi","header__link":"HeaderItem_header__link__dYjUI"};